import { FC, ReactNode } from 'react'
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native'

interface ProductItemProps {
    children: ReactNode
    style?: StyleProp<ViewStyle>
}

const ProductItem: FC<ProductItemProps> = ({ children, style }) => {
    return <View style={[styles.container, style]}>{children}</View>
}

const styles = StyleSheet.create({
    container: {
        paddingVertical: 6,
    },
})

export default ProductItem
